import axios from 'axios';
import jwtDecode from 'jwt-decode';

import { SocialLoginType } from '@pharmaplan/common';

interface IGoogleClaims {
  email?: string;
  given_name?: string;
  family_name?: string;
}

const decodeToken = (jwt: unknown): IGoogleClaims => {
  if (jwt && typeof jwt === 'object') {
    return jwt as IGoogleClaims;
  }
  return {};
};

export const getUserDetails = (code: string) =>
  axios
    .post('https://oauth2.googleapis.com/token', {
      code,
      client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
      client_secret: process.env.REACT_APP_GOOGLE_SECRET,
      redirect_uri: process.env.REACT_APP_REDIRECT_URL,
      grant_type: 'authorization_code',
    })
    .then((res) => {
      const {
        email,
        given_name: givenName,
        family_name: familyName,
      } = decodeToken(jwtDecode(res?.data.id_token));

      return {
        token: res?.data.id_token,
        email: email ?? '',
        firstName: givenName ?? '',
        lastName: familyName ?? '',
        loginType: SocialLoginType.google,
      };
    })
    .catch((err) => {
      console.log(err);
      return {
        token: null,
        email: null,
        firstName: null,
        lastName: null,
        loginType: null,
      };
    });

export const getFacebookDetails = async (
  userID: string,
  accessToken: string,
) => {
  try {
    const userData = await axios.get(
      `https://graph.facebook.com/${userID}?fields=id,name,first_name,last_name,email&access_token=${accessToken}`,
    );
    return {
      token: accessToken,
      email: userData?.data.email,
      firstName: userData?.data.first_name ?? '',
      lastName: userData?.data.last_name ?? '',
      loginType: SocialLoginType.facebook,
    };
  } catch (err) {
    console.log(err);
    return {
      token: null,
      email: null,
      firstName: null,
      lastName: null,
      loginType: null,
    };
  }
};
